import { phoneNumberFormatter } from '../../phoneNumberFormatter.js'

$(document).ready(() => {
  const $form = $('form#edit_distributor');

  if ($form.length === 0) {
    return;
  }

  const phoneNumberInput       = $form[0].querySelector("#phone_number_input");
  const phoneNumberErrorMessage = $form[0].querySelector("#phone_number_error_message");

  phoneNumberFormatter(phoneNumberInput, phoneNumberErrorMessage);
});
